module.exports = __webpack_public_path__ + "img/specif_srb.b4186578.jpg";